import { AlertType } from '../../enums/AlertType';
import { Alert } from '../../interfaces/Alert';
export const ALERT_UPDATE_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'custom.update_success',
    translate: true,
  },
};
